import { render, staticRenderFns } from "./CategoryTabDetails.vue?vue&type=template&id=48fc0f72&scoped=true"
import script from "./CategoryTabDetails.vue?vue&type=script&lang=ts"
export * from "./CategoryTabDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc0f72",
  null
  
)

export default component.exports